import JmPayDashboardContainer from './JmPayDashboardContainer';
export default JmPayDashboardContainer;
